<div style="padding:30px">
    <ul class="nav nav-tabs" style="margin: 10px;" *ngIf="now!='3'">
      <li *ngFor="let item of menu_list;let i = index" (click)="now=item.id;filter_type=now;choose();pageobj.page=0;pageobj.total_count=0"  class="nav-item">
        <a *ngIf="(i==2 && target.uid != '-1') || (i != 2)" onclick="return false;" [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</a>
      </li>
    </ul>
    <select class="form-control"
    *ngIf="now=='1'"
    style="width: 160px;display: inline-block;"
    [(ngModel)]="filter_type"
    (change)="pageobj.page = 0 ;chat_list()"
    >
    <option *ngFor="let item of filter_list" [ngValue]="item.id">{{item.name}}</option>
    </select>
    <input type="text" placeholder="查詢使用者"  style="width: 160px;display: inline-block;" *ngIf="now=='1'" class="form-control"  [(ngModel)]="search_target"  (keyup.enter)="chat_list()">
    <button class="btn btn-danger" (click)="search_target='';chat_list()"  *ngIf="now=='1'" >清除</button>
    <div *ngIf="now=='0'">
        <div class="card" style="width: 18rem;display: inline-block;margin: 20px;height: 350px;overflow: auto;"  *ngFor="let x of data">
            <img loading="lazy" class="card-img-top" style="height: 200px;" [src]="x.profile_pic" alt="Card image cap">
            <div class="card-body" style="height: 85px;overflow: auto;">
              <p class="card-text">{{x.name}}</p>
            </div>
            <div class="card-footer bg-transparent border-success"> <button style="width: 100%;" class="btn btn-primary" (click)="select_user(x)">對話</button></div>
        </div>
        <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
    </div> 
    <div *ngIf="now=='1'">
        <ul class="list-group" *ngFor="let x of data">
            <li class="list-group-item d-flex justify-content-between align-items-center">
                <span (click)="select_user(x)">
                    <img loading="lazy" style="width:50px;margin-right: 10px;cursor:pointer" [src]="x.profile_pic">
                    <span class="user_identity_{{x.identity}}" >{{x.name}}
                        <div *ngIf="x.v_name && x.v_name.length>0">({{x.v_name}})</div>
                    </span>
                </span>
                <span *ngIf="x.unread*1>0" class="badge badge-danger badge-pill">{{x.unread}}</span>
            </li>
          </ul>
          <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
    </div> 
    <div *ngIf="now=='3'">
        <h1>oops...你被踢出連線瞜</h1>
        <span style="color:gray">有其他人使用客服帳號您暫時被踢出連線了</span>
    </div>     
    <div *ngIf="now=='5'">
        <select class="form-control"
        style="width: 160px;display: inline-block;"
        [(ngModel)]="msg_now"
        (change)="pageobj.page = 0 ;get_sheet_return_list()"
        >
        <option *ngFor="let item of feedback_filter_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
           
        <app-table-v2  *ngIf="data.length>0" [type]="1" [tcontent]="tcontent" [data]="data"> 
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key=='descript'">
                    <div style="text-overflow: ellipsis; white-space: nowrap;max-width: 120px; overflow: hidden; ">{{post.val.content}}</div>
                </div>
                <div *ngIf="post.key == 'gg'">
                    <button data-toggle="modal"  data-target=".bd-example-modal-xl" class="btn btn-primary" (click)="edit_data = post.val">觀看</button>
                </div>
            </ng-template>
        </app-table-v2>     
        <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
    </div>     
    <div *ngIf="now=='4'">
        <div class="accordion" id="accordionExample">
            <div class="card">
              <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                  <button 
                  (click)="get_default_edit_data()"
                  class="btn btn-link btn-block text-left" 
                  type="button" data-toggle="collapse" 
                  data-target="#collapseOne" aria-expanded="true" 
                  aria-controls="collapseOne">
                    群發設定
                  </button>
                </h2>
              </div>
          
              <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body">
                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label">參加身分</label>
                        <button (click)="ck_checkbox(1,1)"  [ngClass]="edit_data.identity.indexOf(1)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">一般</button>
                        <button (click)="ck_checkbox(2,1)"  [ngClass]="edit_data.identity.indexOf(2)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">經紀</button>
                        <button (click)="ck_checkbox(3,1)"  [ngClass]="edit_data.identity.indexOf(3)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">內部</button>
                        <div style="display:inline" class="tips">可複選</div>
                    </div>
                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label">性別</label>
                        <button (click)="ck_checkbox(1,2)"  [ngClass]="edit_data.gender.indexOf(1)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">男生</button>
                        <button (click)="ck_checkbox(2,2)"  [ngClass]="edit_data.gender.indexOf(2)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">女生</button>
                        <div style="display:inline" class="tips">可複選</div>
                    </div>
                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label">活躍狀態</label>    
                        <button (click)="edit_data.active_status='0'"  [ngClass]="edit_data.active_status=='0'?'btn-success':'btn-secondary'"  class="btn  m5">全部</button>        
                        <button (click)="edit_data.active_status='1'"  [ngClass]="edit_data.active_status=='1'?'btn-success':'btn-secondary'"  class="btn  m5">活躍用戶</button>
                        <button (click)="edit_data.active_status='-1'"  [ngClass]="edit_data.active_status=='-1'?'btn-success':'btn-secondary'"  class="btn  m5">幽靈用戶</button>
                    </div>
                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label">發送模式</label>            
                        <button (click)="edit_data.send_type='1';edit_data.fcm_notice='0'"  [ngClass]="edit_data.send_type=='1'?'btn-success':'btn-secondary'"  class="btn  m5">指定時間發送</button>
                        <button (click)="edit_data.send_type='0';edit_data.fcm_notice='0'"  [ngClass]="edit_data.send_type=='0'?'btn-success':'btn-secondary'"  class="btn  m5">即時發送</button>
                        <!-- <button (click)="edit_data.send_type='-1';edit_data.fcm_notice='0'"  [ngClass]="edit_data.send_type=='-1'?'btn-success':'btn-secondary'"  class="btn  m5">取消發送</button> -->
                    </div>
                    <!-- <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label">增加Tag類型</label>            
                        <select class="form-control" style="width: 160px;display: inline-block;margin-right: 50px;margin-left: 30px;" [(ngModel)]="tool_obj.tag" (ngModelChange)="showdeType(tool_obj.tag)">
                            <option default disabled value="-2">請選擇Tag類型</option>
                            <option *ngFor="let item of tag_list_type" [ngValue]="item.id">{{item.name}}</option>
                        </select>
                        <mat-form-field  *ngIf="tool_obj.tag > -1" style="width: 600px;">
                            <mat-label>選擇呈現類別</mat-label>
                            <mat-select [(ngModel)]="tool_obj.groupTag" multiple (ngModelChange)="showType(tool_obj.tag)" >
                                <mat-option *ngFor="let item of groupTaglist[tool_obj.tag]" [value]="item.name">{{ item.name }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div  *ngFor="let itex of groupTagArr; let ix = index">
                            <div *ngIf="itex != null">
                                <button  *ngFor="let item of itex; let i = index"  style="margin: 10px;" class="btn btn-primary"  (click)="clearbtn(item,ix,i)" >{{item}}</button>
                            </div>
                        </div>
                    </div> -->

                    <div class="user_edit_block form-group">
                        <app-tagselect (item)="calltagList($event)"></app-tagselect>
                    </div>
                    
                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label">搜尋用戶</label>
                        <button (click)="edit_data.user_mode='1'" [ngClass]="edit_data.user_mode=='1'?'btn-success':'btn-secondary'" class="btn m5">指定</button>
                        <button (click)="edit_data.user_mode='0'" [ngClass]="edit_data.user_mode=='0'?'btn-success':'btn-secondary'" class="btn m5">新增</button>
                        <div class="tips" style="display:inline-block; margin-left:10px;">
                            {{ edit_data.user_mode=='1' ? '只發送給名單內且符合性別/身分的用戶' : '名單內用戶會額外加入發送名單' }}
                        </div>
                        <div>
                            <app-search [openModel]="false" (item)="callitem($event)"></app-search>
                        </div>
                        <div>
                            <button  *ngFor="let item of user_search; let i = index"  style="margin: 10px;" class="btn btn-info" (click)="clearbtnuser(i)">{{item.name}}</button>
                        </div>
                    </div>

                    <div class="user_edit_block form-group" *ngIf="edit_data.send_type==1">
                        <label class="col-sm-2 col-form-label">預約時間</label>
                        <input type="datetime-local" class="form-control show_input" (ngModelChange)="edit_data.target_time = $event"  [ngModel]="edit_data.target_time | date:'yyyy-MM-ddTHH:mm'" />
                    </div>
                    <div class="user_edit_block form-group" *ngIf="edit_data.send_type==1">
                        <label class="col-sm-2 col-form-label">是否推播</label>
                        <button (click)="edit_data.fcm_notice='1'"  [ngClass]="edit_data.fcm_notice=='1'?'btn-success':'btn-secondary'"  class="btn  m5">使用</button>
                        <button (click)="edit_data.fcm_notice='0'"  [ngClass]="edit_data.fcm_notice=='0'?'btn-success':'btn-secondary'"  class="btn  m5">不使用</button>
                    </div>
                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label">發送訊息</label>
                        <textarea class="form-control" placeholder="填訊息嚕" maxlength="500"  [(ngModel)]="edit_data.msg"></textarea>
                    </div>
                    <button (click)="confirm_save(1)" class="btn btn-primary" type="button">儲存</button>
                    <div class="tips">只發送訊息給所有條件都成立的用戶</div>
                </div>
              </div>
            </div>
            <div id="group_msg_list">
                <select class="form-control"
                *ngIf="now=='4' && msg_filter_list.length>0"
                style="width: 160px;display: inline-block;"
                [(ngModel)]="msg_now"
                (change)="pageobj.page = 0 ;group_msg_list()"
                >
                <option *ngFor="let item of msg_filter_list" [ngValue]="item.id">{{item.name}}</option>
                </select>

                <app-table-v2  *ngIf="data.length>0" [type]="1" [tcontent]="tcontent" [data]="data">
                    <ng-template let-post #operation_dk>
                        <div *ngIf="post.key == 'msg'"
                             style="max-width: 220px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                             [title]="post.val.msg">
                            {{ post.val.msg && post.val.msg.length > 100 ? (post.val.msg | slice:0:100) + '…' : post.val.msg }}
                        </div>
                        <div *ngIf="post.key == 'gender'">
                            <span *ngIf="post.val.gender && post.val.gender.length>0 && isArray(post.val.gender)">
                                <span  *ngFor="let sub_item of post.val.gender; let a = index">
                                    {{sub_item*1==1?' 男 ':' 女 '}}
                                </span> 
                            </span> 
                        </div>
                        <div *ngIf="post.key == 'identity'">
                            <span *ngIf="post.val.identity && post.val.identity.length>0 && isArray(post.val.identity)">
                                <span   *ngFor="let sub_item of post.val.identity; let a = index">
                                    {{sub_item==1?' 一般 ':sub_item==2?' 內部 ':' 經濟 '}}
                                </span>
                            </span> 
                        </div>
                        <div *ngIf="post.key == 'active_status'">
                            {{post.val.active_status==0?'全部':post.val.active_status==1?'活躍':'非活躍'}}
                        </div>
                        <div *ngIf="post.key == 'fcm_notice'">
                            {{post.val.fcm_notice==1?'是':'否'}}
                        </div>
                        <div *ngIf="post.key == 'send_type'">
                            <span *ngIf="post.val.send_type == 0">直接發送</span>
                            <span *ngIf="post.val.send_type == 1">預排發送</span>
                            <span *ngIf="post.val.send_type == -1">取消發送</span>
                            <span *ngIf="post.val.send_type == -2">已發送</span>
                        </div>
                        <div *ngIf="post.key == 'gsend_type_time'">
                            <span *ngIf="post.val.send_type != 0">{{post.val.target_time}}</span>                       
                            <span *ngIf="post.val.send_type==0"> - </span>
                        </div>
                        <div *ngIf="post.key == 'gg'">
                            <button data-toggle="modal" *ngIf="post.val.send_type==1" data-target=".bd-example-modal-xl" class="btn btn-primary" (click)="groupTagArr=[];edit_data = post.val;checkData();">編輯</button>
                            <span *ngIf="post.val.send_type!=1"> - </span>
                        </div>
                    </ng-template>
                </app-table-v2>     

                <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
            </div>
        </div>
    </div>     
    <div *ngIf="now=='2'">
        <div class="container" >		
            <div class="caption chat_box" id="chat_box" >		
                <span *ngFor="let item of logs" >
                    <div>
                        <div *ngIf="item.me" style="float:right">
                            <div class="chat_icon">
                               
                                
                                <span *ngIf="item.type*1==1 && item.content.length>0" style="width:150px;word-wrap:break-word;" class="triangle-isosceles top">
                                    <span class="chat_right">{{item.content}}</span>
                                
                                </span>  
                                <span *ngIf="item.type*1==2" class="chat_right">      
                                    <video  style="width:200px;" [src]="item.media.file[0].file_url" controls="controls" ></video>
                                </span>       
                                <span *ngIf="item.type*1==3" class="chat_right">      
                                    <img loading="lazy"  style="width:100px" [src]="item.media.file[0].file_url"> 
                                </span>       
                                <span *ngIf="item.type*1==4" class="chat_right">      
                                    <video  style="width:200px;" [src]="item.media.file[0].file_url" controls="controls" ></video>
                                </span>      
                                <span>{{item.time}}</span>
                                <img loading="lazy" [src]="me.profile_pic" class="user_icon"  style="height:55px" /> 
                               
                                <div style="clear:both;"></div>
                            </div>
                        </div>
                        <div style="clear:both;"></div>
                    </div>
                    <div *ngIf="!item.me" class="speech_item">
                        <div class="chat_icon">
                            <img loading="lazy" [src]="item.user_img" class="user_icon"  style="height:55px" /> 
                            <span>{{item.time}} </span>
                            <span *ngIf="item.type*1==1 && item.content.length>0" style="width:150px;word-wrap:break-word;margin: 5px 0px 0px 0px;" class="triangle-isosceles top">
                                <span class="chat_left">{{item.content}}</span>
                            </span> 
                            <span *ngIf="item.type*1==2" class="chat_left">      
                                <video  style="width:200px;" [src]="item.media.file[0].file_url" controls="controls" ></video>
                            </span>       
                            <span *ngIf="item.type*1==3" class="chat_left">      
                                <img loading="lazy"  style="width:100px" [src]="item.media.file[0].file_url"> 
                            </span>       
                            <span *ngIf="item.type*1==4" class="chat_left">      
                                <video  style="width:200px;" [src]="item.media.file[0].file_url" controls="controls" ></video>
                            </span>      
                            <div style="clear:both;"></div>
                        </div>
                    </div>
                </span>
            </div>
            <div>
                <div style="margin:0 6px 0 0">
                    <img loading="lazy"  style="width:50px;margin:6px" [src]=me.profile_pic><span style="margin:0 10px 0 5px">客服人員</span> 
                    <textarea (keydown.enter)="send()" [(ngModel)]="send_data.msg" class="form-control"></textarea>
                    <div class="form-group">
                        <label for="file">Choose File</label>
                        <input type="file"
                               accept=".jpg,.jpeg,.mp4,.png"
                               id="file"
                               (change)="handleFileInput($event.target.files)">
                    </div>
                </div>
                <div style="visibility: hidden;">
                    <canvas></canvas>
                    <video id="small_show" style="width:200px"  controls src=""></video>
                </div>    
            </div>
        </div>
    </div> 

    <div 
    *ngIf="edit_data"
    class="modal fade bd-example-modal-xl" tabindex="-1"
      role="dialog"  data-keyboard="false" data-backdrop="static" 
      aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
      style="max-height: 680px;overflow:auto;"
      >
      <div class="modal-dialog modal-xl" *ngIf="now=='4'">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title">設定</h5>                
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <!-- Modal body -->
            <div style="padding: 10px;">
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">參加身分</label>
                    <button (click)="ck_checkbox(1,1)"  [ngClass]="edit_data.identity.indexOf(1)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">一般</button>
                    <button (click)="ck_checkbox(2,1)"  [ngClass]="edit_data.identity.indexOf(2)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">經紀</button>
                    <button (click)="ck_checkbox(3,1)"  [ngClass]="edit_data.identity.indexOf(3)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">內部</button>
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">性別</label>
                    <button (click)="ck_checkbox(1,2)"  [ngClass]="edit_data.gender.indexOf(1)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">男生</button>
                    <button (click)="ck_checkbox(2,2)"  [ngClass]="edit_data.gender.indexOf(2)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">女生</button>
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">活躍狀態</label>            
                    <button (click)="edit_data.active_status='1'"  [ngClass]="edit_data.active_status=='1'?'btn-success':'btn-secondary'"  class="btn  m5">活躍用戶</button>
                    <button (click)="edit_data.active_status='0'"  [ngClass]="edit_data.active_status=='0'?'btn-success':'btn-secondary'"  class="btn  m5">全部</button>
                    <button (click)="edit_data.active_status='-1'"  [ngClass]="edit_data.active_status=='-1'?'btn-success':'btn-secondary'"  class="btn  m5">幽靈用戶</button>
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">發送模式</label>            
                    <button (click)="edit_data.send_type='1';edit_data.fcm_notice='0'"  [ngClass]="edit_data.send_type=='1'?'btn-success':'btn-secondary'"  class="btn  m5">指定時間發送</button>
                    <button (click)="edit_data.send_type='0';edit_data.fcm_notice='0'"  [ngClass]="edit_data.send_type=='0'?'btn-success':'btn-secondary'"  class="btn  m5">即時發送</button>
                    <button (click)="edit_data.send_type='-1';edit_data.fcm_notice='0'"  [ngClass]="edit_data.send_type=='-1'?'btn-success':'btn-secondary'"  class="btn  m5">取消發送</button>
                </div>

                <div class="user_edit_block form-group">
                    <!-- <label class="col-sm-2 col-form-label">增加Tag類型</label>            
                    <select class="form-control" style="width: 160px;display: inline-block;margin-right: 50px;margin-left: 30px;" [(ngModel)]="tool_obj.tag" (ngModelChange)="showdeType(tool_obj.tag)">
                        <option default disabled value="-2">請選擇Tag類型</option>
                        <option *ngFor="let item of tag_list_type" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <mat-form-field  *ngIf="tool_obj.tag > -1" style="width: 600px;">
                        <mat-label>選擇呈現類別</mat-label>
                        <mat-select [(ngModel)]="tool_obj.groupTag" multiple (ngModelChange)="showType(tool_obj.tag)" >
                            <mat-option *ngFor="let item of groupTaglist[tool_obj.tag]" [value]="item.name">{{ item.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div  *ngFor="let itex of groupTagArr; let ix = index">
                        <div *ngIf="itex != null">
                            <button  *ngFor="let item of itex; let i = index"  style="margin: 10px;" class="btn btn-primary"  (click)="clearbtn(item,ix,i)" >{{item}}</button>
                        </div>
                    </div> -->
                    <app-tagselect [groupTagArr]="groupTagArr"></app-tagselect>
                </div>


                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">搜尋用戶</label>
                    <button (click)="edit_data.user_mode='1'" [ngClass]="edit_data.user_mode=='1'?'btn-success':'btn-secondary'" class="btn m5">指定</button>
                    <button (click)="edit_data.user_mode='0'" [ngClass]="edit_data.user_mode=='0'?'btn-success':'btn-secondary'" class="btn m5">新增</button>
                    <div class="tips" style="display:inline-block; margin-left:10px;">
                        {{ edit_data.user_mode=='1' ? '只發送給名單內且符合性別/身分的用戶' : '名單內用戶會額外加入發送名單' }}
                    </div>
                    <div>
                        <app-search [openModel]="false" (item)="callitem($event)"></app-search>
                    </div>
                    <div>
                        <button  *ngFor="let item of user_search; let i = index"  style="margin: 10px;" class="btn btn-info" (click)="clearbtnuser(i)">{{item.name}}</button>
                    </div>
                </div>


<!-- {{user_namearr|json}} -->
<!-- {{edit_data.tag_id}} -->

                <div class="user_edit_block form-group" *ngIf="edit_data.send_type==1">
                    <label class="col-sm-2 col-form-label">預約時間</label>            
                    <input type="datetime-local" class="form-control show_input" (ngModelChange)="edit_data.target_time = $event"  [ngModel]="edit_data.target_time | date:'yyyy-MM-ddTHH:mm'" />
                </div>
                <div class="user_edit_block form-group" *ngIf="edit_data.send_type==1">
                    <label class="col-sm-2 col-form-label">是否推播</label>            
                    <button (click)="edit_data.fcm_notice='1'"  [ngClass]="edit_data.fcm_notice=='1'?'btn-success':'btn-secondary'"  class="btn  m5">使用</button>
                    <button (click)="edit_data.fcm_notice='0'"  [ngClass]="edit_data.fcm_notice=='0'?'btn-success':'btn-secondary'"  class="btn  m5">不使用</button>
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">發送訊息</label>            
                    <textarea class="form-control" placeholder="填訊息嚕" maxlength="500"  [(ngModel)]="edit_data.msg"></textarea>
                </div>
            </div>
          
            <!-- Modal footer -->
            <div class="modal-footer" >
                <button type="button"  (click)="confirm_save(0)"    class="btn btn-primary">確認</button>
                <button type="button"  (click)="group_msg_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
          </div>
      </div>
      <div class="modal-dialog modal-xl" *ngIf="now=='5'">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
              <h5 class="modal-title">審查</h5>                
              <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <!-- Modal body -->
          <div style="padding: 10px;">
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">用戶</label>
                    {{edit_data.uname}}
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">時間</label>
                    {{edit_data.occurre_dt}}
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">系統</label>
                    {{edit_data.os_type==2?'iOs':'Android'}}
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">廠牌</label>
                    {{edit_data.phone_brand}}
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">系統版本</label>
                    {{edit_data.os_version}}
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">描述</label>
                    {{edit_data.content}}
                </div>
                <div class="user_edit_block form-group">
                   <label class="col-sm-2 col-form-label">附檔</label>
                    <span *ngFor="let sub_item of edit_data.flist;let i = index">

                        <span style="margin-right:10px ;" *ngIf="edit_data.flist.length>0 && sub_item.url.indexOf('mp4') !=-1 " >     
                            <a href="{{sub_item.url}}" target="_blank">連結{{i + 1}}</a> 
                        </span>
                        <span style="margin-right:10px ;" *ngIf="edit_data.flist.length>0 && sub_item.url.indexOf('mp4') ==-1" >     
                            <a href="{{sub_item.url}}" target="_blank">連結{{i + 1}}</a> 
                        </span>
                        <!-- <img loading="lazy" *ngIf="edit_data.flist.length>0 && sub_item.url.indexOf('mp4') ==-1"  style="width: 50px;margin: 10px;" src="{{sub_item.url}}"> -->
                      
                    </span>
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">狀態</label>
                    <button [ngClass]="edit_data.status==-1?'btn-danger':'btn-secondary'"  (click)="edit_data.status=-1" class="btn" >不處理</button>
                    <button [ngClass]="edit_data.status==0?'btn-danger':'btn-secondary'" (click)="edit_data.status=0" class="btn" >未處理</button>
                    <button [ngClass]="edit_data.status==1?'btn-danger':'btn-secondary'" (click)="edit_data.status=1" class="btn" >處理中</button>
                    <button [ngClass]="edit_data.status==2?'btn-danger':'btn-secondary'" (click)="edit_data.status=2" class="btn" >已結案</button>
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">回復訊息</label>
                    <textarea class="form-control" placeholder="回復訊息" maxlength="500"  [(ngModel)]="edit_data.msg"></textarea>
                </div>
          </div>
        
          <!-- Modal footer -->
          <div class="modal-footer" >
              <button type="button"  (click)="sheet_save()"    class="btn btn-primary" data-dismiss="modal">確認</button>
              <button type="button"  (click)="get_sheet_return_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
          </div>
        </div>
    </div>
    </div>




</div>

<div class="gm-confirm-overlay" *ngIf="confirm_modal.show" (click)="cancel_confirm()">
    <div class="gm-confirm-card" (click)="$event.stopPropagation()">
        <div class="gm-confirm-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="1.5"/>
                <path d="M8 12.5l2.5 2.5L16 9.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="gm-confirm-title">確認發送</div>
        <div class="gm-confirm-count">
            <span class="gm-confirm-num">{{confirm_modal.count}}</span>
            <span class="gm-confirm-unit">位用戶</span>
        </div>
        <div class="gm-confirm-desc">
            訊息將發送給以上人數的用戶<br>確定要儲存嗎？
        </div>
        <div class="gm-confirm-actions">
            <button class="gm-btn gm-btn-cancel" (click)="cancel_confirm()">取消</button>
            <button class="gm-btn gm-btn-confirm" [disabled]="confirm_modal.count==0" (click)="do_save()">確定儲存</button>
        </div>
    </div>
</div>

<div class="gm-toast" *ngIf="toast.show">
    <svg class="gm-toast-icon" width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="11" fill="#10b981"/>
        <path d="M7.5 12.5l3 3 6-6.5" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span>{{toast.msg}}</span>
</div>

<app-spinner [loading]="loading"></app-spinner>